import React, { Fragment } from 'react'
import { makeStyles } from '@material-ui/styles'
import {
  Avatar,
  Button,
  List,
  ListItem,
  Divider,
  ListItemText,
  ListItemAvatar,
  ListItemSecondaryAction
} from '../../Atoms'
import { t as i18n } from 'ttag'
import PropTypes from 'prop-types'

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%'
  },
  inline: {
    display: 'inline'
  }
}))

const propTypes = {
  /** Use the naming standards. */
  id: PropTypes.string.isRequired,
  /**
   * Array of data.
   *
   * `[{ id: 1, logo: { small: 'https://via.placeholder.com/40x40.png?text=CD', `
   * `large: '/assets/products/logo-ComplianceDesktop.jpg' }, link: '/app/cd/home', `
   * `title: 'ComplianceDesktop', description: '' }] `
   *
   */
  list: PropTypes.array
}

const defaultProps = {
  list: {}
}

/**
 * ## ApplicationList generate a list.
 */

const ApplicationList = props => {
  const classes = useStyles()
  const { list, id } = props

  return (
    <List className={classes.root} data-cid='ApplicationList-root' id={id}>
      {list.map(app => (
        <Fragment key={app.id}>
          <ListItem alignItems='flex-start'>
            <ListItemAvatar>
              <Avatar alt={app.title} src={app.logo.small} />
            </ListItemAvatar>
            <ListItemText primary={app.title} secondary={app.description} />
            <ListItemSecondaryAction>
              <Button
                id={id + '_learn'}
                size='small'
                color='primary'
                onClick={app.onClick}
              >{i18n`Learn More`}</Button>
            </ListItemSecondaryAction>
          </ListItem>
          <Divider variant='inset' component='li' />
        </Fragment>
      ))}
    </List>
  )
}

ApplicationList.propTypes = propTypes
ApplicationList.defaultProps = defaultProps

export default ApplicationList
